import { Button, Checkbox, HStack, Image, Stack, Text } from '@chakra-ui/react';
import { useState } from 'react';

interface Props {
  signatureImage: string;
  signing: boolean;
  onConfirm: () => void;
  onBack: () => void;
}

export function ContractStepConfirm({ signatureImage, signing, onConfirm, onBack }: Props) {
  const [agreed, setAgreed] = useState(false);

  return (
    <Stack spacing={4}>
      <Text>Confira sua assinatura abaixo:</Text>
      {signatureImage && (
        <Image
          src={signatureImage}
          alt="assinatura"
          border="1px solid"
          borderColor="gray.300"
          borderRadius="md"
          maxW="400px"
        />
      )}
      <Checkbox isChecked={agreed} onChange={(e) => setAgreed(e.target.checked)}>
        Li e concordo com o conteúdo do contrato.
      </Checkbox>
      <HStack justify="space-between">
        <Button variant="ghost" onClick={onBack} isDisabled={signing}>
          Voltar
        </Button>
        <Button colorScheme="green" onClick={onConfirm} isDisabled={!agreed} isLoading={signing}>
          Assinar contrato
        </Button>
      </HStack>
    </Stack>
  );
}
